export const MAX_MEMBERS_DISPLAYED = 20;
